import { useMemo, useRef, useState } from 'react';

import {
  DropdownMenu2,
  dropdownMenu2Classes,
  type DropdownMenu2ItemData,
  Tooltip,
} from '@kc-console/common-ui';
import IcQuestionCircleSmallRegular from '@kep/kcds-icons/IcQuestionCircleSmallRegular';

import { GnbIconButton } from './GnbIconButton';

import { useHelpdeskMenu } from '@/shared/hooks';
import { resolveHelpdeskMenuOpenUrl } from '@/shared/lib/resolveHelpdeskMenuOpenUrl';

export default function GnbHelpdeskLink() {
  const [open, setOpen] = useState(false);
  const anchor = useRef<HTMLDivElement | null>(null);
  const { helpdeskMenuItems } = useHelpdeskMenu();

  const menuItems = useMemo(() => {
    const sectionItem: DropdownMenu2ItemData = {
      type: 'section',
      title: 'Help Desk',
      header: '도움이 필요하신가요?',
    };
    const optionItems: DropdownMenu2ItemData[] = helpdeskMenuItems.map((menu, index) => ({
      type: 'option',
      text: menu.name,
      showDividerAbove: index === 0,
      onClick: () => window.open(resolveHelpdeskMenuOpenUrl(menu.path), '_blank', 'noopener'),
    }));

    return [sectionItem, ...optionItems];
  }, [helpdeskMenuItems]);

  return (
    <>
      <Tooltip message={'헬프데스크'}>
        <div ref={anchor}>
          <GnbIconButton disableRipple onClick={() => setOpen(prev => !prev)}>
            <IcQuestionCircleSmallRegular />
          </GnbIconButton>
        </div>
      </Tooltip>
      <DropdownMenu2
        anchorEl={anchor.current}
        open={open}
        items={menuItems}
        onClose={() => setOpen(false)}
        css={{
          [`.${dropdownMenu2Classes.paper}`]: {
            width: 248,
          },
        }}
      />
    </>
  );
}
